import React from 'react';
import { useTranslation } from 'react-i18next';

import CPChemicalContainer from './CPChemicalContainer';
import CPHazardsContainer from './CPHazardsContainer';
import CPSdsContainer from './SdsInformation/CPSdsContainer';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import { Grid } from 'semantic-ui-react';
import CPChemicalInformationContainer from '../ChemicalInformation/CPChemicalInformationContainer';
import useUser from '@behavior/init/getUserV2';

const CPGeneralInformationContainer = props => {
  const { t } = useTranslation();
  const {user} = useUser(); 
  return (
    <AccordionWrapper
      {...props}
      closable={false}
      accordionTitle={t('chemical.product.details.page.general.information.container.title')}
      className="containerReducedWhiteSpace"
      render={props => (
        <Grid columns={1}>
          <Grid.Column>
            <CPChemicalContainer {...props} user={user} />
          </Grid.Column>
          <Grid.Column>
            <CPChemicalInformationContainer {...props} />
          </Grid.Column>
          <Grid.Column>
            <CPHazardsContainer
              {...props}
              hazards={props.values.chemicalProduct.hazards || []}
              arrayName="chemicalProduct.hazards"
            />
          </Grid.Column>
          <Grid.Column>
            <CPSdsContainer {...props} />
          </Grid.Column>
        </Grid>
      )}
    />
  );
};

export default CPGeneralInformationContainer;
